import { Radio, Space } from 'antd';
import './RadioInputStyle.css';

const RadioInput = props => {
    const { def, data, onChange, state } = props;
    const direction = def.variant === 'inline' ? 'horizontal' : 'vertical';

    function htmlDecode(input) { //Special case for > and < in Genentech: Herceptin Product Specific Questions. We should move away from storing &gt; and &lt; in the DB going forward
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    return <Radio.Group
        value={data}
        onChange={(e) => { if (!state.readonly) onChange(def.dataKey, e.target.value) }}
        data-input={'radioinput_de'}
        className={'radioinput_de'}
    >
        <Space direction={direction} align='start'>
            {def.values.map((val, idx) => {
                const label = htmlDecode(def.options[idx]);
                const style = direction === 'vertical' ? { marginBottom: '8px' } : {};

                return <Radio
                    value={val}
                    disabled={state.readonly}
                    style={{ ...style, color: 'black !important' }}
                    onClick={() => { if (data === val && !state.readonly) onChange(def.dataKey, null) }}
                    key={idx}
                >
                    {label}
                </Radio>
            })}
        </Space>
    </Radio.Group>
}

export default RadioInput;
